import { FormControl, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { IProductV1 } from "src/domain/entities"
import { FormikOnSubmit } from "src/utils/types"
import { IProductUpdateFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	product: IProductV1
	handleSubmit: FormikOnSubmit<IProductUpdateFormFields>
}

export const ProductUpdateDrawerFormView: FC<Props> = ({
	product,
	handleSubmit,
	...rest
}) => (
	<Formik<IProductUpdateFormFields>
		initialValues={{ name: product.name }}
		onSubmit={handleSubmit}
		enableReinitialize={true}
	>
		{({ values, isSubmitting, handleChange }) => (
			<DrawerForm
				size="sm"
				headerLabel="Update Product"
				submitLabel="Save"
				isSubmitting={isSubmitting}
				{...rest}
			>
				<Stack maxWidth={"sm"} marginX={"auto"}>
					{/* Name */}
					<FormControl>
						<InputLabel label="Product Name" />
						<Input
							name="name"
							placeholder="Name"
							maxLength={50}
							required
							autoFocus
							value={values.name}
							onChange={handleChange}
						/>
						<ErrorMessage component={ErrorMessageField} name="name" />
					</FormControl>
				</Stack>
			</DrawerForm>
		)}
	</Formik>
)
